// localStorage key + URL query param that gate the experimental "Curation AI"
// selector in the submit form. Captured in
// `app/_providers/app-providers.tsx` (and marketing providers) whenever a
// `?ss_curation=true` query param is detected, and consumed by
// `components/VideoTaskForm.tsx` to decide whether to surface the selector.
export const SS_CURATION_KEY = "ss_curation";
export const SS_CURATION_QUERY_PARAM = "ss_curation";

// Whether the "Curation AI" selector should be available to the user. Reads
// the persisted localStorage flag set when the `?ss_curation=true` param was
// seen. Returns false during SSR (no `window`).
export const isOneshotCurationSelectorEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(SS_CURATION_KEY) === "true";
  } catch {
    return false;
  }
};
